import Styles from "./Login.module.scss";
import clsx from "clsx";
import MenuVTC from "../Share/Component/MenuVtc";
import useSignInPage from "../Hooks/useSignInPage";
import { Controller } from "react-hook-form";
import { LoginInput } from "../Components/Atoms/LoginInput";
import ClientProfile from "../Components/Molecules/ClientProfile";
import ReCaptcha from "../Components/Molecules/ReCaptcha";
import { signup,accuracy } from "../Api/SubUrl";

function Login() {
  const {
    showProfile,
    user,
    control,
    handleSubmit,
    handleClose,
    introduceId,
    version,
    reCaptchaV2,
    isLoadReCaptChaV3,
    recaptchaLoading,
    recaptchaError,
    isDefaultV3,
    loading,
  } = useSignInPage();

  const canShowProfile = showProfile;
  return (
    <>
      <div className={clsx(Styles.main, "flex-grow-1")}>
        <div
          className={clsx(Styles.formBox, "form-box")}
          style={{ opacity: canShowProfile ? 0 : 1 }}
        >
          <div className={clsx(Styles.formValue, "form-value")}>
            <h2>ĐĂNG NHẬP</h2>
            <form onSubmit={handleSubmit} className={clsx(Styles.form)}>
              <Controller
                name="userName"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <LoginInput
                    label="TÀI KHOẢN"
                    id="userName"
                    value={field.value}
                    onChange={field.onChange}
                    error={error}
                  />
                )}
              />
              <Controller
                name="password"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <LoginInput
                    label="MẬT KHẨU"
                    id="password"
                    value={field.value}
                    onChange={field.onChange}
                    error={error}
                    type="password"
                  />
                )}
              />

              <ReCaptcha
                version={version}
                isDefaultV3={isDefaultV3}
                reCaptchaV2={reCaptchaV2}
                recaptchaLoading={recaptchaLoading}
                recaptchaError={recaptchaError}
                isLoadReCaptChaV3={isLoadReCaptChaV3}
              />

              <button 
                className={clsx(Styles.span,{ [Styles.disabled]: loading })} 
                type="submit" 
                disabled={loading}
              >
                {loading ? "Đang đăng nhập..." : "Đăng nhập"}
              </button>
              <div className={clsx(Styles.register, "register")}>
                <p>
                  Chưa có tài khoản <a href={signup}>Đăng Ký</a>
                </p>
                <p>
                  <a href={accuracy}>Quên mật khẩu</a>
                </p>
              </div>
            </form>
          </div>
        </div>
        {!canShowProfile && <MenuVTC />}
      </div>
      {canShowProfile && user ? (
        <ClientProfile
          showProfile={canShowProfile}
          handleClose={handleClose}
          data={user}
          introduceId={introduceId}
        />
      ) : null}
    </>
  );
}
export default Login;
